import React, { useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useEntity } from '../../contexts/EntityContext';
import { useArea } from '../../contexts/AreaContext';
import { useYear } from '../../contexts/YearContext';

const AdminPage: React.FC = () => {
    const history = useHistory();
    const { clearCurrentEntity } = useEntity();
    const { clearCurrentArea } = useArea();
    const { clearCurrentYear } = useYear();

    useEffect(() => {
        clearCurrentEntity?.();
        clearCurrentArea?.();
        clearCurrentYear?.();
        localStorage.removeItem('currentEntityId');
        localStorage.removeItem('currentAreaId');
        localStorage.removeItem('currentYear');
    }, [clearCurrentEntity, clearCurrentArea, clearCurrentYear]);

    return (
        <div className="container py-5">
            <h2 className="mb-4">Administração</h2>
            <Row className="g-4">
                <Col md={6}>
                    <Card className="entity-card" onClick={() => history.push('/admin/usuarios')} style={{ cursor: 'pointer' }}>
                        <Card.Body className="d-flex justify-content-between align-items-center">
                            <div>
                                <Card.Title className="text-dark">Usuários</Card.Title>
                                <Card.Text>
                                    Gerencie usuários do sistema, permissões e perfis de acesso.
                                </Card.Text>
                            </div>
                            <div className="icon-container">
                                <i className="mdi mdi-account text-dark" style={{ fontSize: 36 }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="entity-card" onClick={() => history.push('/admin/entidade')} style={{ cursor: 'pointer' }}>
                        <Card.Body className="d-flex justify-content-between align-items-center">
                            <div>
                                <Card.Title className="text-dark">Entidades</Card.Title>
                                <Card.Text>
                                    Gerencie entidades, áreas e configurações institucionais.
                                </Card.Text>
                            </div>
                            <div className="icon-container">
                                <i className="mdi mdi-domain text-dark" style={{ fontSize: 36 }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="entity-card" onClick={() => history.push('/admin/questoes')} style={{ cursor: 'pointer' }}>
                        <Card.Body className="d-flex justify-content-between align-items-center">
                            <div>
                                <Card.Title className="text-dark">Questões Base</Card.Title>
                                <Card.Text>
                                    Gerencie questões, itens e ações bases para cada área do sistema de avaliação.
                                </Card.Text>
                            </div>
                            <div className="icon-container">
                                <i className="mdi mdi-file-document-multiple text-dark" style={{ fontSize: 36 }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="entity-card" onClick={() => history.push('/admin/publicar')} style={{ cursor: 'pointer' }}>
                        <Card.Body className="d-flex justify-content-between align-items-center">
                            <div>
                                <Card.Title className="text-dark">Publicação de Questões</Card.Title>
                                <Card.Text>
                                    Publique as questões bases para as entidades selecionadas.
                                </Card.Text>
                            </div>
                            <div className="icon-container">
                                <i className="mdi mdi-file-document-multiple text-dark" style={{ fontSize: 36 }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default AdminPage;
